<template>
<v-layout row wrap>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <!--
      <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
      -->
      <v-btn color="pink" dark small fixed top right fab style="top:44px" v-on="on">
        <v-icon>add</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <v-select
                :items="['daejeon', 'test']"
                v-model="editedItem.group"
                label="group"
                single-line
                />
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="editedItem.name" label="충전소 이름"></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field v-model="editedItem.address" label="충전소 위치(주소)"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="editedItem.location.latitude" label="좌표(위도)"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model="editedItem.location.longitude" label="좌표(경도)"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="$_close">취소</v-btn>
        <v-btn color="blue darken-1" flat @click="$_save">저장</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-flex xs12>
    <v-card>
      <v-data-table
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        :headers="headers"
        :items="datas"
        :loading="loading">
        <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.group }}</td>
          <td class="text-xs-left">{{ props.item.address }}</td>
          <td class="text-xs-left">{{ $_getLocationString(props.item.location) }}</td>
          <td class="justify-center layout px-0">
              <v-icon
                small
                class="mr-2"
                @click="$_editItem(props.item)"
              >
                edit
              </v-icon>
              <v-icon
                small
                @click="$_deleteItem(props.item)"
              >
                delete
              </v-icon>
            </td>
        </template>
      </v-data-table>
    </v-card>
  </v-flex>

  <!--
  <v-btn fixed dark fab bottom right color="pink"
    @click="$router.push({name:'PlaceAdd'})">
    <v-icon>add</v-icon>
  </v-btn>
  -->

</v-layout>
</template>

<script>
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'

export default {
  name: 'HelloWorld',
  data () {
    return {
      headers: [{text: '이름', values: 'name', sortable: false},
        {text: 'group', values: 'group', sortable: false},
        {text: '위치', values: 'address', sortable: false},
        {text: '좌표', values: 'location', sortable: false},
        {text: '관리', values: 'actions', sortable: false}],
      datas: [],
      rowsPerPageItems: [10, 20, 50, 100, 200],
      pagination: {
        rowsPerPage: 200
      },
      dialog: false,
      editedIndex: -1,
      editedItem: {
        group: this.$store.state.session.group,
        name: '',
        address: '',
        location: {latitude: null, longitude: null}
      },
      defaultItem: {
        group: this.$store.state.session.group,
        name: '',
        address: '',
        location: {latitude: null, longitude: null}
      },
      loading: false
      // items: [{ header: '충전소 목록' }]
    }
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? '충전소 신규 등록' : '충전소 정보 수정'
    }
  },
  watch: {
    '$route' (to, from) {
      this.$_getPlaces()
    },
    dialog (val) {
      val || this.$_close()
    }
  },
  created () {
    this.$emit('title', '충전소 관리')
    this.$_getPlaces()
  },
  methods: {
    $_getLocationString (geoPoint) {
      if (geoPoint) {
        return (geoPoint.latitude || '') + ', ' + (geoPoint.longitude || '')
      }
    },
    $_getPlaces () {
      this.loading = true

      let query = this.$fs.collection('places')
      if (!this.$store.state.session.admin) {
        query = query.where('group', '==', this.$store.state.session.group)
      }

      query
        .orderBy('name')
        .get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // console.log(`${doc.id} => ${doc.data()}`)

            var item = doc.data()
            item.id = doc.id
            this.datas.push(item)
            // this.items.push({ divider: true, inset: false })
            // console.log(doc.data())
          })

          this.loading = false
        }).catch(error => {
          if (error) {
            // TODO 오류 처리
          }
          this.loading = false
        })
    },
    $_editItem (item) {
      // console.log('edit', item)

      // this.$router.push({name:'PlaceEdit', params:{'id':item.id, 'place':item}})
      this.editedIndex = this.datas.indexOf(item)

      if (typeof (item.location) === 'undefined') {
        item.location = {longitude: null, latitude: null}
      } else {
        item.location = {longitude: item.location.longitude, latitude: item.location.latitude}
      }
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    $_deleteItem (item) {
      if (item.chargerRefs) {
        if (item.chargerRefs.length > 0) {
          alert('해당 충전소는 충전기가 할당 되어 있습니다.\n충전소-충전기 구성에서 먼저 제거하세요.')
          return
        }
      }

      if (item.checkerRef) {
        if (item.checkerRef.length > 0) {
          alert('해당 충전소는 점검자가 할당 되어 있습니다.\n점검자-충전소 구성에서 먼저 제거하세요.')
          return
        }
      }

      const index = this.datas.indexOf(item)
      const name = item.name
      const inputPlaceName = prompt('해당 "' + name + '" 충전소를 정말 삭제하시겠습니까?\n해당 충전소 이름을 한번 더 정확하게 입력하세요.')

      if (name === inputPlaceName) {
        // TODO loading

        /*
        // 연결되어 있는 charger, checker 정보 같이 삭제...
        // transaction 을 사용하여 reference 가 실제 존재하지 않는 경우를 처리하려고 했으나
        // Every document read in a transaction must also be written. 오류 발생으로 원복함.
        // transaction 은 해당 문서가 있을 경우 read 후 반드시 write 를 해야 함.
        const checkerRef = place.checkerRef
        let job = null

        if (checkerRef) {
          job = this.$fs.db().runTransaction(t => { // Every document read in a transaction must also be written.
            return t.get(checkerRef)
              .then(doc => {

                try {
                  console.log('000', checkerRef, placeRef)
                  if (doc.exists) { // Every document read in a transaction must also be written.
                    let placeRefs = doc.data().placeRefs
                    console.log('111', placeRefs)

                    for (var i = 0; i < placeRefs.length; i++) {
                      if (placeRefs[i].id === place.id) {
                        placeRefs.splice(i, 1)
                        break;
                      }
                    }

                    console.log('222', placeRefs)

                    //console.log('chargers 2', chargers)
                    t.update(checkerRef, {'placeRefs': placeRefs,
                                updated: firebase.firestore.FieldValue.serverTimestamp()})
                  }
                  console.log('333')

                  // update chargers doc...
                  if (place.chargerRefs) {
                    // TODO :: checker 는 찾아 보고 update 하지만, charger 는 그 방법을 찾지 못해
                    // 우선 찾지 않고 바로 update 해 버림.
                    // 추후 방법을 찾을 것.
                    for (var i = 0; i < place.chargerRefs; i++) {
                      t.update(place.chargerRefs[i], {'placeRef': firebase.firestore.FieldValue.delete(),
                                  updated: firebase.firestore.FieldValue.serverTimestamp()})
                    }
                  }

                  t.delete(placeRef)

                  return Promise.resolve(doc)
                } catch (error) {
                  return Promise.reject(error)
                }
              })
          })
        } else {
          const batch = this.$fs.db().batch()

          if (place.chargerRefs) {
            // TODO :: checker 는 찾아 보고 update 하지만, charger 는 그 방법을 찾지 못해
            // 우선 찾지 않고 바로 update 해 버림.
            // 추후 방법을 찾을 것.
            for (var i = 0; i < place.chargerRefs; i++) {
              batch.update(place.chargerRefs[i], {'placeRef': firebase.firestore.FieldValue.delete(),
                          updated: firebase.firestore.FieldValue.serverTimestamp()})
            }
          }

          batch.delete(placeRef)

          job = batch;
        }
        */

        this.$fs
          .collection('places')
          .doc(item.id)
          .delete()
          .then(() => {
            // 로컬 데이터 업데이트
            this.datas.splice(index, 1)

            this.$emit('snackbar', '삭제되었습니다.')
            this.$_close()
          }).catch(error => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      } else if (inputPlaceName) {
        this.$emit('snackbar', '충전소 이름을 다시 확인하세요.')
      }
    },
    $_close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    $_save () {
      if (this.editedIndex > -1) { // 수정
        // TODO loading
        const item = this.datas[this.editedIndex]
        const placeId = item.id
        const group = item.group

        if (group !== this.editedItem.group) {
          if (item.chargerRefs) {
            if (item.chargerRefs.length > 0) {
              alert('해당 충전소는 충전기가 할당 되어 있습니다.\n그룹 변경을 위해서 충전소-충전기 구성에서 먼저 제거하세요.')
              return
            }
          }

          if (item.checkerRef) {
            if (item.checkerRef.length > 0) {
              alert('해당 충전소는 점검자가 할당 되어 있습니다.\n그룹 변경을 위해서 점검자-충전소 구성에서 먼저 제거하세요.')
              return
            }
          }
        }

        const updateData = {group: this.editedItem.group,
          name: this.editedItem.name,
          address: this.editedItem.address,
          updated: firebase.firestore.FieldValue.serverTimestamp()}

        if (this.editedItem.location.longitude > 0 && this.editedItem.location.latitude > 0) {
          updateData.location = new firebase.firestore.GeoPoint(parseFloat(this.editedItem.location.longitude, 10),
            parseFloat(this.editedItem.location.latitude, 10))
        }

        this.$fs.collection('places')
          .doc(placeId)
          .set(updateData, {merge: true})
          .then(() => {
            // 로컬 데이터 업데이트
            Object.assign(this.datas[this.editedIndex], this.editedItem)

            this.$emit('snackbar', '수정되었습니다.')
            this.$_close()
          }).catch((error) => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      } else { // 신규
        // TODO loading
        // 서버 데이터 업데이트
        this.$fs.collection('places')
          .add(Object.assign({created: firebase.firestore.FieldValue.serverTimestamp()}, this.editedItem))
          .then(() => {
            // 로컬 데이터 업데이트
            this.datas.push(this.editedItem)

            this.$emit('snackbar', '등록되었습니다.')
            this.$_close()
          }).catch((error) => {
            console.error('Error adding document: ', error)
            this.$_close()
          })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Place/PlaceList.vue